// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* For information on how to create your own theme, please see:
http://ionicframework.com/docs/theming/ */
/* @import "~bootstrap/dist/css/bootstrap.css"; */
/* @import url("https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap"); */

body {
  margin: 0;
  font-family: "DM Sans", sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #f7f8fa;
}

:root {
  --primaryColor: #146c94;
  --BackgroundColor: #eeeeee;
}


.ImageLogin{
  width: 80%;
  height: 100vh;
  padding-left: 80px;
}

.containerLogin {
  width: 438px;
}

@media only screen and (max-width: 767px) {
  .containerLogin {
    width: 100%;
  }
}

.EnableButton {
  color: white !important;
  background-color: #1E5198;
  text-transform: capitalize;
  border-radius: 8px;
}

.CancelButton {
  color: #1E5198 !important;
  border-color: #1E5198 !important;
}

.LabelLogin {
  font-size: 14px;
  margin-top: 20px;
  font-weight: 700;
}
.required {
  font-weight: 200;
  color: red;
}

.containerContent {
  position: absolute;
  bottom:50px;
  font-size: 32px;
  width: 40%;
  font-weight: 700;
  margin-left: 32px;
}

.form-control:focus {
  box-shadow: none !important;
}

.GridRight{
  max-height: 100vh;
  overflow-y: scroll;
}

.GridRight::-webkit-scrollbar {
  width: 8px;
}

.GridRight::-webkit-scrollbar-thumb {
  background-color: rgb(255 255 255);
}

.GridRight::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}

.panelYes {
  text-decoration: underline;
  color: #1e5198 !important;
  font-weight: 700;
  cursor: pointer;
  margin-top: 3px;

}
.panelNo {
  cursor: pointer;
  margin-top: 3px;
}
.w-40 {
  width: 35% !important;
}

nextjs-portal {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;yCACyC;AACzC,iDAAiD;AACjD,qIAAqI;;AAErI;EACE,SAAS;EACT,6CAA6C;EAC7C,mCAAmC;EACnC,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;;;AAGA;EACE,UAAU;EACV,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,UAAU;EACV,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,eAAe;;AAEjB;AACA;EACE,eAAe;EACf,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf","sourcesContent":["/* For information on how to create your own theme, please see:\nhttp://ionicframework.com/docs/theming/ */\n/* @import \"~bootstrap/dist/css/bootstrap.css\"; */\n/* @import url(\"https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap\"); */\n\nbody {\n  margin: 0;\n  font-family: \"DM Sans\", sans-serif !important;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: #f7f8fa;\n}\n\n:root {\n  --primaryColor: #146c94;\n  --BackgroundColor: #eeeeee;\n}\n\n\n.ImageLogin{\n  width: 80%;\n  height: 100vh;\n  padding-left: 80px;\n}\n\n.containerLogin {\n  width: 438px;\n}\n\n@media only screen and (max-width: 767px) {\n  .containerLogin {\n    width: 100%;\n  }\n}\n\n.EnableButton {\n  color: white !important;\n  background-color: #1E5198;\n  text-transform: capitalize;\n  border-radius: 8px;\n}\n\n.CancelButton {\n  color: #1E5198 !important;\n  border-color: #1E5198 !important;\n}\n\n.LabelLogin {\n  font-size: 14px;\n  margin-top: 20px;\n  font-weight: 700;\n}\n.required {\n  font-weight: 200;\n  color: red;\n}\n\n.containerContent {\n  position: absolute;\n  bottom:50px;\n  font-size: 32px;\n  width: 40%;\n  font-weight: 700;\n  margin-left: 32px;\n}\n\n.form-control:focus {\n  box-shadow: none !important;\n}\n\n.GridRight{\n  max-height: 100vh;\n  overflow-y: scroll;\n}\n\n.GridRight::-webkit-scrollbar {\n  width: 8px;\n}\n\n.GridRight::-webkit-scrollbar-thumb {\n  background-color: rgb(255 255 255);\n}\n\n.GridRight::-webkit-scrollbar-track {\n  background-color: #f1f1f1;\n}\n\n.panelYes {\n  text-decoration: underline;\n  color: #1e5198 !important;\n  font-weight: 700;\n  cursor: pointer;\n  margin-top: 3px;\n\n}\n.panelNo {\n  cursor: pointer;\n  margin-top: 3px;\n}\n.w-40 {\n  width: 35% !important;\n}\n\nnextjs-portal {\n  display: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
